import { z } from 'zod';

const clientEnvSchema = z.object({
  VITE_API_URL: z.string(),
  VITE_TRON_USDT_CONTRACT_ADDRESS: z.string(),
  VITE_BSC_USDT_CONTRACT_ADDRESS: z.string(),
  VITE_D9_USDT_CONTRACT_ADDRESS: z.string(),
  VITE_D9_NODE_URL: z.string(),
  VITE_NETWORK_MODE: z.enum(['testnet', 'mainnet']),
  VITE_SENTRY_DSN: z.string().optional(),
});

export type IClientEnv = z.output<typeof clientEnvSchema>;
export const clientEnv: IClientEnv =
  typeof window === 'undefined'
    ? ({} as IClientEnv)
    : (clientEnvSchema.parse(import.meta.env) as IClientEnv);

console.info('Client Env', clientEnv);
